import { Breadcrumb } from "pepsico-ds";
import AppConfigurationsForm from "../../components/management/AppConfigurations/AppConfigurationsForm";
import { paths } from "../../routes/paths";

export default function AppConfigurationsEditPage() {
  return (
    <div className="container">
      <div className="wrap">
        <Breadcrumb
          breadcrumbs={[
            {
              label: "Program Settings",
              href: `../../${paths.system_setting}`,
            },
            {
              label: "Edit App Configurations",
              href: `../../${paths.system_setting}/${paths.app_configurations}/edit`,
            },
          ]}
          activeIndex={1}
        />
        <div className="heading-wrap">
          <h2>App Configurations</h2>
        </div>
        <div className="app-configurations-form">
          <AppConfigurationsForm isEditPage={true} />
        </div>
      </div>
    </div>
  );
}
